import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ActionSheetController,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { GenericFormValidationProvider } from '../../providers/common/form-validation';

/**
 * Generated class for the WelcomeletterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-welcomeletter',
  templateUrl: 'welcomeletter.html',
})
export class WelcomeletterPage {
communicationEmail:any="";
   
  errorDisplay:any={};
  listCategotyComplains:any=[];
  listSubCategotyComplains:any=[];
  category:any="";
  subcomplain:any="";
  ccs_remarks:any="";
  reason:any=""
  contactDtailsData:any;
  constructor(
    private loadingCtrl:LoadingController,

    public actionSheetCtrl: ActionSheetController,private fv:GenericFormValidationProvider, public navCtrl: NavController, public navParams: NavParams,private cp:CommonProvider) {
  }

  ionViewDidLoad() {
    this.contactDtailsData = this.navParams.data.addressDetail.responseParameters.filter((res:any)=>{
      return res.mailingaddress=="Y" && res.addresstype== "CURRES" && res.applicanttype=='Applicant'
    })[0];
    this.communicationEmail = this.contactDtailsData.emailid
    //console.log('ionViewDidLoad WelcomeletterPage');
  }
   presentActionSheet(msg) {
    const actionSheet = this.actionSheetCtrl.create({
      title: msg,
      cssClass: 'commanSheet',
      buttons: [
        {
          text: "OK",
          role: 'Ok',
          handler: () => {
             actionSheet.dismiss();
          }
        }
      ]
    });
    actionSheet.present();
  }
  postFormForValidation(){
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms["foreclousreEnquiry"],true,[]);
     
    if(this.errorDisplay.valid){
     return false;
   }else{
    let loading = this.loadingCtrl.create({
            content: 'Please wait...'
          });
     loading.present()
    var ccs_casecategory="CC03";;
    var ccs_casetype="CT22";
    var ibhfl_loanaccountnumber1=localStorage.getItem('cc');
    var ccs_originatingsource="S011"
    var ccs_casesubtype = "ST204";
    var ccs_remarks = ""
    this.cp.postWelcomeLetter(loading,ccs_casecategory,ccs_remarks,
                           JSON.parse(localStorage.getItem("existingLoan"))[0].customercode,ccs_casetype,
                           ibhfl_loanaccountnumber1,
                           ccs_originatingsource,
                           ccs_casesubtype).then((res:any)=>{
                            loading.dismiss();
                            var res=JSON.parse(res);
                            this.presentActionSheet("Your SRno. "+res.Payload.caseid+" has been resolved.")
                           })
   
   }
   }

}



// WEBPACK FOOTER //
// ./src/pages/welcomeletter/welcomeletter.ts